import React from "react";

import { IndividualApplication } from "IndividualApplication/types";
import { FieldArray } from "react-final-form-arrays";
import { formatNameFL } from "Utils/formatName";
import { validateRequired, validateSSN, composeValidators } from "Utils/Validations";

import { SurfaceSection } from "Cobalt/Surface";
import { SIFinalFormField } from "Common/forms";
import { ssnMask } from "Common/forms/masks";
import { Row } from "Common/Grid";

import type { StyleProps } from "Utils/styleProps";

interface DependentSSNsProps extends StyleProps {
  dependents: Array<any>;
  fields: any;
}

interface SSSectionProps extends StyleProps {
  individualApplication: IndividualApplication;
  dependents: Array<any>;
}

const SSNField = ({ fieldName, person }) => (
  <SIFinalFormField
    name={fieldName}
    label={[formatNameFL(person)].join(" ")}
    hint="SSN or Tax ID"
    props={{ mask: ssnMask }}
    validate={!person?.socialSecurityNumber && composeValidators(validateRequired, validateSSN)}
    componentProps={{ disabled: !!person?.socialSecurityNumber }}
    sm={4}
  />
);

const DependentSSNs = ({ dependents, fields }: DependentSSNsProps) => (
  <div>
    {fields.map((member, index) => (
      <Row key={index}>
        <SSNField fieldName={`${member}.socialSecurityNumber`} person={dependents[index]} />
      </Row>
    ))}
  </div>
);

export const IndividualSSNSection = ({ individualApplication, dependents }: SSSectionProps) => (
  <SurfaceSection
    title="We need the social security number (or tax ID number) for
    each person in your family who's enrolling"
  >
    <Row>
      <SSNField fieldName="socialSecurityNumber" person={individualApplication} />
    </Row>
    <FieldArray name="dependents" component={DependentSSNs} dependents={dependents} />
  </SurfaceSection>
);
